/**
 * 메뉴 액션 버스 — 메뉴에만 있는 기능을 편집기 툴바(App)에서 부르기 위한 통로.
 *
 * 모니터링 창 같은 메뉴 기능의 핸들러는 Header 안의 로컬 상태(setShow…)에 있어서, 툴바를
 * 그리는 App 이 직접 부를 수 없다. 모달 상태를 전부 끌어올리는 대신:
 *
 *   · Header 가 자기 메뉴 목록(표시명·아이콘)을 **게시**하고
 *   · 툴바 버튼은 실행을 Header 의 handleMenuClick 으로 **되돌린다**
 *
 * 그래서 메뉴 정의도 한 곳(Header), 실행·기록 경로도 한 곳(handleMenuClick)에 남는다.
 * 두 번째 실행 경로를 만들지 말 것 — 만들면 한쪽에서 사용로그가 빠진다.
 */
import { useSyncExternalStore } from 'react';

let catalog = {};
let runner = null;
const listeners = new Set();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return catalog;
}

/** Header 가 호출한다. 목록이 바뀔 때만 부르면 된다(구독자가 다시 그린다). */
export function publishMenuActions(next) {
  catalog = next;
  listeners.forEach(l => l());
}

/** Header 가 호출한다 — 실행은 메뉴 클릭과 같은 함수로. */
export function registerMenuRunner(fn) {
  runner = fn;
}

/** 툴바 버튼이 호출한다. Header 가 아직 없으면 조용히 아무것도 안 한다. */
export function runMenuAction(id) {
  if (runner) runner(id);
}

/** { [actionId]: { name, icon } } — 이 모드에서 메뉴에 실제로 있는 것만 들어 있다. */
export function useMenuActions() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
